import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';

export interface TreeBrowserState {
  /** Expanded node ids per browser key, so expansion outlives page unmounts. */
  expandedIds: Record<string, string[]>;
  /** Last resolved selection per browser key; held while a page reloads its record. */
  selectedIds: Record<string, string>;
}

const initialState: TreeBrowserState = {
  expandedIds: {},
  selectedIds: {},
};

export const treeBrowserSlice = createSlice({
  name: 'treeBrowser',
  initialState,
  reducers: {
    setTreeBrowserExpandedIds: (
      state,
      action: PayloadAction<{key: string; ids: string[]}>
    ) => {
      state.expandedIds[action.payload.key] = action.payload.ids;
    },
    setTreeBrowserSelectedId: (
      state,
      action: PayloadAction<{key: string; id: string}>
    ) => {
      state.selectedIds[action.payload.key] = action.payload.id;
    },
  },
});

export const {setTreeBrowserExpandedIds, setTreeBrowserSelectedId} =
  treeBrowserSlice.actions;

export default treeBrowserSlice.reducer;
